import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { useLplModel } from "../lplModel";
import { ColumnsType } from "antd/lib/table";
import { offerService } from "@/views/inquires/offer/offerService";
import { IOfferDetail } from "@/views/inquires/offer/offerTypes";
import moment from "moment";


export const OfferDialog = () => {
    const { offerDialog: { visible, codes }, setDialog } = useLplModel(({ offerDialog }) => [offerDialog])
    //列表数据源
    const [dataSource, setDataSource] = useState<IOfferDetail[]>([]);
    const [loading, setLoadding] = useState<boolean>(false);

    useEffect(() => {
        if (visible) {
            loadData()
        } else {
            setDataSource([])
        }
    }, [visible])

    const getOrderOne = async (id: string) => {
        try {
            let { retData } = await offerService.one(id);
            return retData
        } catch {
            return null
        }
    }

    const loadData = async () => {
        // setLoadding(true)
        if (!codes) return
        const tempArr = codes.split(",");
        const newArr = [];
        for (let i = 0; i < tempArr.length; i++) {
            let res = await getOrderOne(tempArr[i]);
            res && newArr.push(res)
        }
        setDataSource(newArr)
        // setLoadding(false)
    }

    const onCancel = () => {
        setDialog("offer", false);
    };


    const column: ColumnsType<any> = [
        {
            title: '序号',
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '报价单号',
            dataIndex: 'realCode',
        }, {
            title: '报价日期',
            dataIndex: 'createTime',
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''

        }
    ];


    return <YHModal
        visible={visible}
        onOk={onCancel}
        onCancel={onCancel}
        title="报价详情"
        width={600}
        bodyHeight={400}
        showFooter={true}
    >
        <YhBox title=" " style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                rowKey={record => record.id}
                loading={loading}
                columns={column}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    </YHModal>
}